module.exports = __webpack_public_path__ + "img/brown-carpet-grass-07.44a4d5a6.png";